import {useSelector} from 'react-redux'
import {useGetHotelDetails} from 'hooks/useGetHotelDetails'
import {HotelOfferEntity} from 'modules/sapiSearch/slice'
import {getIsNoDatesSearch} from 'modules/search/selectors'

import {AccommodationOfferBox} from '../AccommodationOfferBox/AccommodationOfferBox'
import {DatelessOfferBox} from '../DatelessOfferBox/DatelessOfferBox'
import {TopOffersDesktop} from '../TopOffers/Desktop/TopOffersDesktop'

interface OfferBoxDesktopContainerProps {
  hotelId: string
  offerEntity: HotelOfferEntity
  isVioOfferSelected: boolean
  isRedirectToStandaloneAP: boolean
  isOffersOrRoomsLoading: boolean
  cashback: {
    enabled: boolean
  }
}

export const OfferBoxDesktopContainer: React.FC<
  OfferBoxDesktopContainerProps
> = ({
  hotelId,
  offerEntity,
  isVioOfferSelected,
  isRedirectToStandaloneAP,
  isOffersOrRoomsLoading,
  cashback
}) => {
  const isNoDatesSearch = useSelector(getIsNoDatesSearch)

  const {data: hotel} = useGetHotelDetails(hotelId)

  if (isNoDatesSearch && hotel) {
    return (
      <DatelessOfferBox priceFrom={hotel?.pricing?.minRateInUserCurrency} />
    )
  }

  if (!isVioOfferSelected && isRedirectToStandaloneAP)
    return (
      <TopOffersDesktop
        offerEntity={offerEntity}
        isLoading={isOffersOrRoomsLoading}
        showCashback={cashback.enabled}
      />
    )

  return (
    <AccommodationOfferBox
      offerEntity={offerEntity}
      isLoading={isOffersOrRoomsLoading}
      showCashback={cashback.enabled}
    />
  )
}
